<style scoped>
  .negrito {font-weight: bold !important;}
  .w-full {width: 100%}
  .w-half { width: 50%}
  .input {text-align: right;}
  .texto-centralizado {text-align: center;}
</style>

<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title is-large w-full" >
        <b-tag type="is-primary" size="is-large" class="texto-centralizado w-full m-l-sm">Definir Produtos do Pedido</b-tag>
      </div>

      <div class="has-text-right p-sm">
        <button type="button" class="button" @click="fechar">Fechar</button>
      </div>

    </div>
    <section class="card-content">

      <b-field label="Produto"
               :type="$errorType('produto', errors)"
               :message="errors.first('produto')">
        <v-select class="w-full" ref="produto"
                  placeholder="Selecione um produto"
                  label="label"
                  :maxHeight="'190px'"
                  :value.sync="selecionado"
                  :options="produtosDisponiveis"
                  :loading="loadingForm"
                  inputId="produtoSelect"
                  :on-change="atualizarProduto"
                  name="produto" data-vv-as="Produto" v-validate="'required'">
        </v-select>
      </b-field>

      <div class="columns">
        <div class="column">
          <b-field label="Quantidade"
                   :type="$errorType('quantidade', errors)"
                   :message="errors.first('quantidade')">
            <b-input ref="QUANT" name="quantidade"
                     v-model.number="produto.selecionado.QUANT"
                     @keyup.enter.native="mudarFocoQuantidade"
                     :disabled="!selecionado"
                     data-vv-as="Quantidade" v-validate="'required|verifica_embalagem'">
            </b-input>
          </b-field>
        </div>
        <div class="column" v-if="this.parametrosPortal.PERMITE_DESC_CABECALHO === 'S'">
          <b-field label="Desc. (pedido)">
            <input ref="descCabecalho" v-model.lazy="descCabecalho" disabled
                   v-money="porcentagem" class="input">
          </b-field>
        </div>
        <div class="column" v-if="parseFloat(descAdicional) > 0">
          <b-field label="Desc. (adicional)">
            <input ref="descCabecalho" v-model.lazy="descAdicional" disabled
                   v-money="porcentagem" class="input">
          </b-field>
        </div>
        <div class="column">
          <b-field label="UM/Embalagem">
            <b-taglist attached>
              <b-tag class="w-half" type="is-primary" size="is-medium">{{produto.selecionado.B1_UM}}</b-tag>
              <b-tag class="w-half" type="is-info" size="is-medium" expanded>{{produto.selecionado.EMBALAGEM}}</b-tag>
            </b-taglist>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field label="Valor tabela">
            <b-input type="number" v-model.number="produto.selecionado.VALOR_TABELA"
                     step="00.01" class="negrito"
                     disabled></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field label="Valor c/ desc"
                   :type="$errorType('VALOR_VENDA', errors)"
                   :message="errors.first('VALOR_VENDA')">
            <b-input v-model="produto.selecionado.VALOR_VENDA"
                     class="negrito" ref="valorVenda" name="VALOR_VENDA"
                     disabled></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Total do item (R$)">
            <b-input v-model="produto.selecionado.VALOR_TOTAL"
                     disabled ref="valorTotal" ></b-input>
          </b-field>
        </div>
      </div>

      <div class="columns">

      </div>
      <footer class="has-text-right">
        <button type="button" class="button" @click="cancelar">Cancelar</button>

        <button ref="addproduto" class="button is-primary" :class="{'is-loading':loadingForm}"
                @click="adicionarProduto" :disabled="!selecionado">
          <b-icon icon="check"/> <span>Adicionar</span>
        </button>
      </footer>

    </section>

  </div>
</template>

<script>
  import vSelect from '../../../components/Select.vue'
  import {VMoney} from 'v-money'
  import { Validator } from 'vee-validate'

  export default {
    directives: {money: VMoney},
    components: {vSelect},
    props: [
      'produto',
      'tabela',
      'itens',
      'parametrosPortal',
      'descontoCabecalho',
      'descontoAdicional',
      'embalagens',
      'cliente'
    ],
    created () {
      this.descCabecalho = this.$clonar(this.descontoCabecalho)
      this.descAdicional = this.$clonar(this.descontoAdicional)
      this.carregarTabela()
      this.validarQuantidade()
    },
    data () {
      return {
        descCabecalho: 0,
        descAdicional: 0,
        descontoItem: [],
        selecionado: null,
        produtosDisponiveis: [],
        grupos: [],
        grupoDescontos: [],
        loadingForm: false,
        porcentagem: {
          decimal: '.',
          thousands: '',
          prefix: '',
          suffix: '%',
          precision: 2,
          masked: false
        },
        moedabr: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        }
      }
    },
    methods: {
      mudarFocoQuantidade () {
        if (!this.produto.selecionado.QUANT || this.produto.selecionado.QUANT === 0) {
          return
        }
        if (this.parametrosPortal.PERMITE_DESC_ITEM === 'S' && this.parametrosPortal.TIPO_DESC_ITEM !== 'U') {
          this.$refs.desconto.focus()
        } else {
          this.adicionarProduto()
        }
      },
      validarDesconto () {
        let desconto = (this.produto.selecionado.DESCONTO_TOTAL) ? parseFloat(this.produto.selecionado.DESCONTO_TOTAL) : 0
        this.$validator.errors.remove('desconto')
        this.$validator.errors.remove('VALOR_VENDA')
        if (this.parametrosPortal.PERMITE_DESC_ITEM === 'S') {
          let descMax
          let comissaoProduto
          if (this.parametrosPortal.TIPO_DESC_ITEM === 'L') {
            descMax = 100.00
            comissaoProduto = '8,00'
          } else if (this.parametrosPortal.TIPO_DESC_ITEM === 'G' && this.descontoItem.length > 0) {
            // descMax = this.descontoItem.reduce(
            //   (max, d) => d.QZ3_DESMAX > max ? d.QZ3_DESMAX : max, this.descontoItem[0].QZ3_DESMAX)
            descMax = this.descontoItem.reduce(function (descAnterior, descAtual) {
              if (parseFloat(descAtual.QZ3_DESMAX) >= parseFloat(descAnterior)) {
                return descAtual.QZ3_DESMAX
              } else {
                return descAtual
              }
            }, this.descontoItem[0].QZ3_DESMAX)
            comissaoProduto = this.descontoItem.reduce(
              (comiss, d) => (desconto >= d.QZ3_DESMIN) && (desconto <= d.QZ3_DESMAX)
                ? d.QZ3_COMISS : comiss, this.descontoItem[0].QZ3_COMISS)
          } else if (this.parametrosPortal.TIPO_DESC_ITEM === 'U') {
            comissaoProduto = this.produto.selecionado.COMISSAO_ITEM
          }
          if (this.produto.selecionado.VALOR_VENDA <= 0) {
            this.$validator.errors.add({field: 'VALOR_VENDA', msg: 'O Valor c/ desc precisa ser maior que 0'})
            return false
          }
          if (desconto > descMax) {
            this.$validator.errors.add({field: 'desconto', msg: 'O desconto máximo é de ' + descMax + '%'})
            return false
          } else {
            this.$refs.comissao.$emit('input', comissaoProduto)
            return true
          }
        }
        return true
      },
      validarQuantidade () {
        Validator.extend('verifica_embalagem', {
          getMessage: field => `A ${field} precisa ser múltiplo da embalagem.`,
          validate: value => new Promise((resolve) => {
            let emb = (!this.produto.selecionado || !this.produto.selecionado.EMBALAGEM) ? 0.01 : this.produto.selecionado.EMBALAGEM
            resolve({
              valid: value && ((value / emb) % 1 === 0 ||
                ((parseFloat(value) + parseFloat(emb)) / emb) % 1 === 0)
            })
          })
        })
      },
      cancelar () {
        this.selecionado = null
        this.produto.selecionado = this.resetProdutoSelecionado()
      },
      fechar () {
        this.selecionado = null
        this.produto.selecionado = null
        this.$emit('close')
      },
      atualizarProduto (value) {
        if (value && value.DA1_CODPRO) {
          this.$validator.errors.remove('produto')
          let numItem = this.produto.selecionado.NUMITEM
          let jaExisteNaLista = this.itens.filter(item => {
            return (item.COD_ITEM === value.DA1_CODPRO) && (item.NUMITEM !== numItem)
          })
          if (jaExisteNaLista && jaExisteNaLista.length > 0) {
            this.$validator.errors.add({field: 'produto', msg: 'Este produto já foi incluído no pedido.'})
          } else {
            this.$validator.errors.remove('produto')
            this.selecionado = value
            if (value.QZ2_GRUPO && this.grupoDescontos.length > 0) {
              this.descontoItem = this.grupoDescontos.filter(d => {
                return (d.QZ3_GRUPO === value.QZ2_GRUPO) && (d.QZ3_TABELA === value.QZ2_TABELA)
              })
            }
            if (this.parametrosPortal.TIPO_DESC_ITEM === 'U') {
              this.produto.selecionado.DESCONTO_TOTAL = this.parametrosPortal.DESCONTO_ITEM_PADRAO
            }
            this.produto.selecionado.VALOR_TABELA = value.DA1_PRCVEN
            this.produto.selecionado.COD_ITEM = value.DA1_CODPRO
            this.produto.selecionado.DESCRICAO = value.B1_DESC
            this.produto.selecionado.B1_UM = value.B1_UM
          }
          this.atualizarQtdEmbalagem(value)
        }
        this.$refs.QUANT.focus()
      },
      atualizarQtdEmbalagem (produto) {
        if (this.embalagens && Array.isArray(this.embalagens) && this.embalagens.length > 0) {
          let embalagem
          let clienteSelecionado = this.cliente
          embalagem = this.embalagens.filter(emb => {
            return (emb.QZ3_COD === produto.DA1_CODPRO &&
              emb.QZ3_CLIE === clienteSelecionado.A1_COD &&
              emb.QZ3_LOJA === clienteSelecionado.A1_LOJA)
          })
          if (embalagem.length > 0) {
            embalagem = embalagem[0]
          } else {
            embalagem = this.embalagens.filter(emb => emb.QZ3_COD === produto.DA1_CODPRO && (!emb.QZ3_CLIE && !emb.QZ3_LOJA))
            if (embalagem.length > 0) {
              embalagem = embalagem[0]
            } else {
              embalagem = null
            }
          }
          if (!embalagem) {
            this.produto.selecionado.EMBALAGEM = 1
          } else {
            this.produto.selecionado.EMBALAGEM = embalagem.QZ3_QUANT
          }
        } else {
          this.produto.selecionado.EMBALAGEM = 1
        }
      },
      adicionarProduto () {
        this.$validator.validateAll().then(res => {
          if (res && this.validarDesconto()) {
            this.loadingForm = true
            let msg = ''
            if (this.produto.selecionado.NUMITEM) {
              this.itens[this.produto.selecionado.NUMITEM - 1] = this.produto.selecionado
              msg = 'Produto alterado com sucesso!'
            } else {
              this.produto.selecionado.NUMITEM = this.itens.length + 1
              this.itens.push(this.produto.selecionado)
              msg = 'Produto adicionado com sucesso!'
            }
            this.produto.selecionado = this.resetProdutoSelecionado()
            this.selecionado = null
            document.getElementById('produtoSelect').focus()
            this.loadingForm = false
            this.$toast.open({
              message: msg,
              type: 'is-success',
              duration: 7 * 1000
            })
          }
        })
      },
      resetProdutoSelecionado () {
        return {
          B1_UM: '',
          COD_FILIAL: '01',
          COD_ITEM: '',
          DESCONTO_TOTAL: 0,
          COMISSAO_ITEM: 0,
          DESCRICAO: '',
          NUMITEM: null,
          QUANT: 0,
          VALOR_TABELA: 0,
          VALOR_VENDA: 0,
          EMBALAGEM: 1
        }
      },
      carregarTabela () {
        this.produtosDisponiveis = []
        this.loadingForm = true
        this.$http.get(this.$URL.TABELA_PRECO.BASE + this.tabela, this.$header()).then(res => {
          this.produtosDisponiveis = res.body
          this.loadingForm = false
        }, res => {
          this.$toast.open(res.body)
          this.loadingForm = false
        })
      },
      atualizarValores () {
        let descontoCab = (this.descCabecalho) ? parseFloat(this.descCabecalho) : 0
        let descontoAdic = (this.descAdicional) ? parseFloat(this.descAdicional) : 0
        let desconto = (this.produto.selecionado.DESCONTO_TOTAL) ? parseFloat(this.produto.selecionado.DESCONTO_TOTAL) : 0
        let valorBruto = this.produto.selecionado.VALOR_TABELA
        let valorFinal = valorBruto - this.$valorDesconto(descontoCab, valorBruto)
        valorFinal = valorFinal - this.$valorDesconto(descontoAdic, valorFinal)
        valorFinal = valorFinal - this.$valorDesconto(desconto, valorBruto)
        this.$refs.valorVenda.$emit('input', this.$converterDecimal(valorFinal))
        if (this.produto.selecionado.VALOR_VENDA && this.produto.selecionado.QUANT) {
          let valor = parseFloat(this.produto.selecionado.VALOR_VENDA) * parseFloat(this.produto.selecionado.QUANT)
          this.$refs.valorTotal.$emit('input', valor.toFixed(2))
        } else {
          this.$refs.valorTotal.$emit('input', 0)
        }
        this.validarDesconto()
      }
    },
    watch: {
      'produto.selecionado.COD_ITEM' (value) {
        this.$refs.valorVenda.$emit('input', parseFloat(this.produto.selecionado.VALOR_TABELA).toFixed(2))
        this.atualizarValores()
      },
      'produto.selecionado.QUANT' (value) {
        this.atualizarValores()
      },
      'produto.selecionado.DESCONTO_TOTAL' (value) {
        this.atualizarValores()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/pedido/piller/FormProdutoPiller.vue